'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _debounce = require('lodash-es/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _identity = require('lodash-es/identity');

var _identity2 = _interopRequireDefault(_identity);

var _noop = require('lodash-es/noop');

var _noop2 = _interopRequireDefault(_noop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Výčet možných stavů načítání jedné položky.
 *
 * @enum {string}
 */
var LoadState = {
    LOADING: 'LOADING',
    LOADED: 'LOADED',
    ERROR: 'ERROR',
    CANCELED: 'CANCELED'
};

var getItemData = function getItemData(item) {
    return item.data;
};

/**
 * Utilita pro asynchronní načítání dle dle příslušného klíče.
 * - Načtená data jsou dle klíče interně cachována.
 * - Umí notifikovat o změně průběhu načítání.
 * - Umí vracet načtená data a stav průběhu načítání.
 */

var CachingLoader = function () {

    /**
     * Konstruktor.
     *
     * @param {function} itemLoader - callback pro synchronní či asynchronní načtení dat jedné položky dle jejího klíče
     * @param {Object} [options] - volitelné parametry
     * @param {function} [options.resultDataExtractor] - callback pro získání dat položky z výsledku jejího načtení
     * @param {function} [options.onLoadStateChange] - callback volaný při změně stavu načítání položek
     * @param {number} [options.loadDelay] - spoždění načítání (debounce)
     */
    function CachingLoader(itemLoader) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, _classCallCheck3.default)(this, CachingLoader);

        this.items = new _map2.default();
        this.itemLoader = itemLoader;
        this.resultDataExtractor = options.resultDataExtractor || _identity2.default;
        this.onLoadStateChange = options.onLoadStateChange || _noop2.default;

        var loadDelay = options.loadDelay;

        if (loadDelay != null) {
            this.loadItems = (0, _debounce2.default)(this.loadItems.bind(this), loadDelay);
        }
    }

    /**
     * Spustí načítání položek s příslušnými klíči.
     * - Průběh načítání každé položky je uložen dle klíče do interní cache
     * - Pro položky nalezené dle klíče v cache se použije existující stav načítání.
     * - Z cache jsou odstraněny položky, na jejichž klíče se nedotazujeme.
     *
     * @param {Array<*>} keys - pole klíčů položek
     * @param {Object} [options] - volitelé parametry
     * @param {boolean} [options.reloadErrors=false] -  příznak, zda vynutit opětovné načtení položek v cache,
     *                                                  u nichž skončilo přechozí načítání chybou
     */


    (0, _createClass3.default)(CachingLoader, [{
        key: 'loadItems',
        value: function loadItems(keys) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var _options$reloadErrors = options.reloadErrors,
                reloadErrors = _options$reloadErrors === undefined ? false : _options$reloadErrors;

            var loadStateChanged = false;

            // Odstraníme nepotřebné položky z cache
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.items.keys()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;

                    if (keys.indexOf(key) <= 0) {
                        this._deleteItem(key);
                        loadStateChanged = true;
                    }
                }

                // Přidáme nové položky do cache
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(keys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _key = _step2.value;

                    if (!this.items.has(_key)) {
                        this.items.set(_key, {});
                    }
                }

                // Spustíme načítání u některých položek
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = (0, _getIterator3.default)(this.items), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var _step3$value = (0, _slicedToArray3.default)(_step3.value, 2),
                        _key2 = _step3$value[0],
                        item = _step3$value[1];

                    var state = item.state;

                    if (state == null || reloadErrors && state === LoadState.ERROR) {
                        this._loadItem(_key2, item);
                        loadStateChanged = true;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            if (loadStateChanged) {
                this.onLoadStateChange();
            }
        }

        /**
         * Spustí načítání jedné položky.
         *
         * @param {*} key - klíč položky
         * @param {Object} item - záznam položky
         * @private
         */

    }, {
        key: '_loadItem',
        value: function _loadItem(key, item) {
            var _this = this;

            item.state = LoadState.LOADING;

            try {
                _promise2.default.resolve(this.itemLoader(key)).then(function (result) {
                    return _this._onItemLoadSuccess(item, result);
                }).catch(function (error) {
                    return _this._onItemLoadError(item, error);
                });
            } catch (error) {
                this._onItemLoadError(item, error);
            }
        }

        /**
         * Callback volaný při úspěšném načtení položky.
         *
         * @param {*} item - záznam položky
         * @param {*} result - výsledek načtení
         * @private
         */

    }, {
        key: '_onItemLoadSuccess',
        value: function _onItemLoadSuccess(item, result) {
            if (item.state === LoadState.CANCELED) {
                return;
            }

            try {
                item.state = LoadState.LOADED;
                item.data = this.resultDataExtractor(result);
            } catch (error) {
                item.state = LoadState.ERROR;
                item.error = error;
            }

            this.onLoadStateChange();
        }

        /**
         * Callback volaný při chybě načtení položky.
         *
         * @param {*} item - záznam položky
         * @param {*} error - chyba načtení
         * @private
         */

    }, {
        key: '_onItemLoadError',
        value: function _onItemLoadError(item, error) {
            if (item.state === LoadState.CANCELED) {
                return;
            }

            item.state = LoadState.ERROR;
            item.error = error;

            this.onLoadStateChange();
        }

        /**
         * Smaže záznam položky z cache.
         *
         * @param {*} key - klíč položky
         * @private
         */

    }, {
        key: '_deleteItem',
        value: function _deleteItem(key) {
            var item = this.items.get(key);
            if (item) {
                item.state = LoadState.CANCELED;
                this.items.delete(key);
            }
        }

        /**
         * Otestuje, zda právě probíhá načítání.
         *
         * @returns {boolean} true, pokud se načítá alespoň jedna položka, jinak false
         */

    }, {
        key: 'isLoading',
        value: function isLoading() {
            return this._existItemsWithState(LoadState.LOADING);
        }

        /**
         * Vrátí iterátor, který projde data načtených položek.
         *
         * @returns {IterableIterator<*>} iterátor
         */

    }, {
        key: 'getLoadedData',
        value: function getLoadedData() {
            return this._getItemsWithState(LoadState.LOADED, getItemData);
        }

        /**
         * Otestuje, zda exsituje alespoň jedna položka v daném stavu.
         *
         * @param {LoadState} state - stav načítání
         * @returns {boolean} true, pokud existuje alespoň jedna položka v daném stavu, jinak false
         * @private
         */

    }, {
        key: '_existItemsWithState',
        value: function _existItemsWithState(state) {
            return !this._getItemsWithState(state).next().done;
        }

        /**
         * Vrátí iterátor nad položkami v daném stavu.
         *
         * @param {LoadState} state - stav načítání
         * @param {function} mapFunction - mapovací funkce pro každou z položek
         * @returns {IterableIterator<*>} iterátor
         * @private
         */

    }, {
        key: '_getItemsWithState',
        value: /*#__PURE__*/_regenerator2.default.mark(function _getItemsWithState(state) {
            var mapFunction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity2.default;

            var _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, item;

            return _regenerator2.default.wrap(function _getItemsWithState$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _iteratorNormalCompletion4 = true;
                            _didIteratorError4 = false;
                            _iteratorError4 = undefined;
                            _context.prev = 3;
                            _iterator4 = (0, _getIterator3.default)(this.items.values());

                        case 5:
                            if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                                _context.next = 13;
                                break;
                            }

                            item = _step4.value;

                            if (!(item.state === state)) {
                                _context.next = 10;
                                break;
                            }

                            _context.next = 10;
                            return mapFunction(item);

                        case 10:
                            _iteratorNormalCompletion4 = true;
                            _context.next = 5;
                            break;

                        case 13:
                            _context.next = 19;
                            break;

                        case 15:
                            _context.prev = 15;
                            _context.t0 = _context['catch'](3);
                            _didIteratorError4 = true;
                            _iteratorError4 = _context.t0;

                        case 19:
                            _context.prev = 19;
                            _context.prev = 20;

                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }

                        case 22:
                            _context.prev = 22;

                            if (!_didIteratorError4) {
                                _context.next = 25;
                                break;
                            }

                            throw _iteratorError4;

                        case 25:
                            return _context.finish(22);

                        case 26:
                            return _context.finish(19);

                        case 27:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _getItemsWithState, this, [[3, 15, 19, 27], [20,, 22, 26]]);
        })
    }]);
    return CachingLoader;
}();

exports.default = CachingLoader;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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